module.exports = __webpack_public_path__ + "static/media/scissors.18aaee3a.svg";